import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'

class Counter extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.init = 2000000 - 299700

    this.ref = {
      no: []
    }

  }


  mount() {

    this.ref.no.reverse()

    var startDate = new Date('Jan 22 2024 18:00:00');
    this.sd = startDate.getTime()
    // Do your operations
    var endDate = new Date();
    var seconds = (endDate.getTime() - this.sd) / 1000;

   

    this.number = this.init + Math.ceil(seconds / 4);
    this.nostring = this.number.toString().split('')
    this.nostring.reverse()

    _each(this.ref.no, (item, i) => {
        item.dataset.nr = this.nostring[i]
        item.innerHTML = this.nostring[i]
    })

    this.bindedshow = this.change.bind(this)
    //this.delayedCall = gsap.delayedCall(.3, this.bindedchange)
    //this.show()

    gsap.set(this.bindedshow, {
        onRepeat: this.bindedshow,
        repeat: -1,
        repeatDelay: 2
    });


   

  }

  change() {
        var endDate = new Date();
        var seconds = ( endDate.getTime() - this.sd ) / 1000;


        this.number = this.init + Math.ceil(seconds / 4);
        var nostring = this.number.toString().split('') 
        nostring.reverse()

        //this.nostringreversed = this.nostring.slice().reverse()

        _each(this.ref.no, (item, i) => {
            item.dataset.nr = nostring[i]
            
            if (Number(item.dataset.nr) != Number(item.innerHTML)) {
                gsap.to(item, {
                    yPercent: -100,
                    duration: .77, 
                    onComplete : ()=>{
                        item.innerHTML = item.dataset.nr
                        gsap.to(item, {
                            yPercent: 0,
                            duration: 0
                        })
                    }
                })
            }

            //console.log(this.nostringreversed[i]);
        })


  }

  unmount() {
   
  }


  



}


module.exports = Counter
